import {tagActions} from '../actions/tagDataAction'

const initialState = {
    tags:undefined,
    all_tags:undefined,
    filter_tags:undefined
};

export const reducer = (state = initialState, action)=>{
    switch (action.type) {
        case tagActions.recieveTags:
            return{...state,
                tags:action.payload.tag_categories,
                all_tags:action.payload.all_tags,
                filter_tags:action.payload.tag_categories
            };
            //break;
        case tagActions.updateFilterTags:
            return{
                ...state,
                filter_tags:action.payload
            };
            //break;
        case tagActions.resetFilterTags:
            return{
                ...state,
                filter_tags: action.payload
            };
            //break;
        default:
            return state;
    }
}